import React from "react";
import { Row, Col, Form, Input, Button } from "antd";
import {
  MailOutlined,
  PhoneOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";

function PersonalDetailsForm({ form, userDetails }) {
  const whatsappNumber = "917092925555";

  const requestMessage = `Hi DIVE HRZN,

I would like to request an update to my registered phone number.

Name: ${[userDetails?.firstName, userDetails?.lastName]
    .filter(Boolean)
    .join(" ") || "Not provided"}
Email: ${userDetails?.email || "Not provided"}
Existing phone number: ${userDetails?.phoneNo || "Not provided"}

Please help me update my registered phone number.`;

  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
    requestMessage
  )}`;

  return (
    <Row gutter={[24, 24]} style={{ padding: 8, paddingTop: 0 }}>
      <Col xs={24}>
        <Form
          form={form}
          layout="vertical"
          initialValues={{ email: userDetails?.email }}
        >
          <Row gutter={16}>
            <Col xs={12} sm={12}>
              <Form.Item label="First name">
                <Input
                  value={userDetails?.firstName}
                  disabled={!!userDetails?.firstName}
                />
              </Form.Item>
            </Col>

            <Col xs={12} sm={12}>
              <Form.Item label="Last name">
                <Input
                  value={userDetails?.lastName}
                  disabled={!!userDetails?.lastName}
                />
              </Form.Item>
            </Col>

            <Col xs={24}>
              <Form.Item label="Email">
                <Input
                  prefix={<MailOutlined />}
                  value={userDetails?.email}
                  disabled
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={20}>
              <Form.Item label="Phone number">
                <Input
                  prefix={<WhatsAppOutlined />}
                  value={userDetails?.phoneNo}
                  disabled={!!userDetails?.phoneNo}
                  style={{ fontSize: "16px" }}
                />
              </Form.Item>
            </Col>

            <Col xs={24}>
              <Button
                type="primary"
                icon={<WhatsAppOutlined />}
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                block
                style={{
                  backgroundColor: "#25D366",
                  borderColor: "#25D366",
                  height: 44,
                }}
              >
                Request Phone Number Update
              </Button>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  );
}

export default PersonalDetailsForm;